module.exports = __webpack_public_path__ + "img/png3.a1d52524.png";